import { Button } from "@heroui/react";
import { Plus, FileSpreadsheet, CalendarPlus } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { BulkUploadDialog } from "./bulk-upload-dialog";
import { SchedulePickupSheet } from "./schedule-pickup-sheet";

export function CreateOrderButton({ mobile = false }: { mobile?: boolean }) {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const bulkUploadButton = (
    <Button
      size="md"
      variant="bordered"
      className="w-full sm:w-auto"
      onPress={() => setBulkUploadOpen(true)}
      startContent={<FileSpreadsheet className="h-4 w-4" />}
    >
      {t("createOrderButton.bulkUpload")}
    </Button>
  );
  const schedulePickupButton = (
    <Button
      size={mobile ? "sm" : "md"}
      variant="bordered"
      className={mobile ? "min-h-11" : "w-full sm:w-auto"}
      onPress={() => setScheduleOpen(true)}
      startContent={<CalendarPlus className="h-4 w-4" />}
    >
      {t("createOrderButton.schedulePickup")}
    </Button>
  );

  return (
    <>
      <div
        className={
          mobile ? "w-full" : "flex flex-col sm:flex-row gap-2 w-full sm:w-auto"
        }
      >
        <Button
          size="md"
          color="primary"
          className={mobile ? "w-full" : "w-full sm:w-auto"}
          onPress={() => void navigate("/new-shipment/details")}
          startContent={<Plus className="h-4 w-4" />}
        >
          {t("createOrderButton.newShipment")}
        </Button>
        {mobile ? (
          <div className="mt-1 flex items-center justify-between gap-2">
            <Button
              isIconOnly
              size="sm"
              variant="light"
              className="min-h-11 min-w-11"
              aria-label={t("createOrderButton.bulkUpload")}
              onPress={() => setBulkUploadOpen(true)}
            >
              <FileSpreadsheet className="h-5 w-5" />
            </Button>
            {schedulePickupButton}
          </div>
        ) : (
          <>
            {bulkUploadButton}
            {schedulePickupButton}
          </>
        )}
      </div>

      <BulkUploadDialog
        open={bulkUploadOpen}
        onOpenChange={setBulkUploadOpen}
      />
      {/* Phase 11b wizard for batching N shipments onto one new pickup booking.
          Always available from the Shipments header; empty-state handled inside
          the wizard if no LABEL_READY shipments exist. Remount via key so each
          open starts with a fresh idempotency key + state. */}
      <SchedulePickupSheet
        key={scheduleOpen ? "open" : "closed"}
        open={scheduleOpen}
        onClose={() => setScheduleOpen(false)}
      />
    </>
  );
}
